import { GetPayLoad } from "./PayLoadStorage";

// Function to handle Fiserv SSO login by creating and submitting a form
const handleFiservLogin = () => {

    const Payload = GetPayLoad('PayLoad');
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const targetFiservUrl = baseUrl + process.env.REACT_APP_API_FISERV_LOGIN_ENDPOINT;
    
    // Create a form element
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = targetFiservUrl;
    form.target = '_blank'; // Open in a new tab or window

    // Add form fields
    const fields = {
        cim: Payload?.cim,
        region: Payload?.region,
        case_num: Payload?.case_num,
        state: Payload?.state || null,
        "X-Hps-Client-Id": process.env.REACT_APP_API_CLIENT_ID,
        "X-Hps-Secret-Id": process.env.REACT_APP_API_SECRET_ID,
        "X-Hps-Region": Payload?.region,
        "X-Hps-Carrier": Payload?.owning_carrier
    };

    for (const key in fields) {
        if (fields[key] !== undefined) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = key;
        input.value = fields[key];
        form.appendChild(input);
        }
    }
    // Append the form to the body, submit it, and remove it
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);

}

export { handleFiservLogin };